import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { User } from '../../../entities/user.model';
import { AppTranslateService } from 'src/app/services/translate.service';
import { AnalyticsService } from 'src/app/services/gtag.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [IonicModule, CommonModule, RouterModule, FormsModule, TranslateModule],
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  email = '';
  password = '';
  errorMessage = '';
  user: User | null = null;
  temporary: boolean = false;
  public isNative: boolean = typeof Capacitor !== 'undefined' && Capacitor.isNativePlatform && Capacitor.isNativePlatform();

  constructor(private authService: AuthService, private router: Router, private appTranslate: AppTranslateService, private translate: TranslateService, private gtagService: AnalyticsService) {}

  ngOnInit() {
    document.title = 'LingDisco';
    this.authService.currentUser$.subscribe(user => {
      this.user = user;
      if (this.user) {
        console.log('Current user:', this.user);
        if (!this.user.email) {
          this.temporary = true;
        }
        if (this.user.targetLanguage && this.user.nativeLanguage && this.user.level && Object.keys(this.user.level).length > 0 && this.user.completedTour) {
          // If all user properties are set, navigate to grammar home
          this.router.navigate(['/playlists']);
        }
        else if (this.user.targetLanguage && this.user.nativeLanguage && this.user.level && Object.keys(this.user.level).length > 0 && !this.user.completedTour) {
          console.log('User is missing completedTour');
          this.router.navigate(['/welcome']);
        }
      }
    });
  }

  async loginWithEmail() {
    try {
      const firebaseUser =  await this.authService.signInWithEmail(this.email, this.password);
      if (firebaseUser) {
        this.gtagService.trackEvent('login', 'email', 'success');
        // Set user ID for better analytics tracking
        await this.gtagService.setUserId(firebaseUser.uid);
        this.router.navigate(['/playlists']);
      }
      else {
        this.errorMessage = 'Invalid email or password';
      }
    } catch (error) {
      this.errorMessage = 'Invalid email or password';
    }
  }
  
  async loginWithGoogle() {
    try {
      const firebaseUser = await this.authService.signInWithGoogle();
      if (firebaseUser) {
        this.gtagService.trackEvent('login', 'google', 'success');
        // Set user ID for better analytics tracking
        await this.gtagService.setUserId(firebaseUser.uid);
        this.router.navigate(['/playlists']);
      }
    } catch (error: any) {
      console.error('Google Sign-In error (loginWithGoogle):', error);
      this.errorMessage = 'Google Sign-In failed';
    }
  }

  async loginWithApple() {
    try {
      const result = await this.authService.signInWithApple();
      if (result) {
        const { user: firebaseUser, isNewUser } = result;
        this.gtagService.trackEvent('login', 'apple', 'success');
        // Set user ID for better analytics tracking
        await this.gtagService.setUserId(firebaseUser.uid);
        
        // If user is new, redirect to beginning flow
        if (isNewUser) {
          this.router.navigate(['/beginning']);
        } else {
          this.router.navigate(['/playlists']);
        }
      }
    } catch (error) {
      console.error('Apple Sign-In error:', error);
      this.errorMessage = 'Apple Sign-In failed';
    }
  }

  goToSignUp() {
    this.router.navigate(['/signup']);
  }

  getStarted() {
    this.gtagService.trackEvent('login', 'anonymous');
    this.router.navigate(['/beginning']);
  }

  // Test method to verify analytics is working
  async testAnalytics() {
    console.log('[LoginPage] Testing analytics...');
    await this.gtagService.testAnalytics();
    
    // Also test page tracking
    await this.gtagService.trackScreen('Login Test Screen', { test_param: 'test_value' });
  }
}
